import { FileType } from 'constants/constants';
import { indexOf } from 'lodash';

let ImageResizer = {};

    // CSS & Styles
export function backgroundImage(url) {
  if(!url) return {};
  return { backgroundImage:"url('" + url + "')" };
}


  // Image & Media
export function isImageFile(type) {
  return type.indexOf("image/") !== -1;
}

export function isVideoFile(type) {
  return type.indexOf("video/") !== -1;
}

export function isAudioFile(type) {
  return type.indexOf("audio/") !== -1;
}

export function getFileType(type) {
  if(isImageFile(type)) {
    return FileType.IMAGE
  } else if(isVideoFile(type)) {
    return FileType.VIDEO;
  } else if(isAudioFile(type)) {
    return FileType.AUDIO;
  }
  return;
}

export function getFileExtension(filename) {
  let re = /(?:\.([^.]+))?$/;
  return re.exec(filename)[1];
}

export function extensionFromFile(file) {
  if(!file || !file.type) return '';
  let ext = file.type.split('/').pop();
  switch(ext) {
    case 'jpeg':
      return 'jpg';
    default:
      return ext;
  }
}

export function getTypeFromFile(file) {
  return getFileType(file.type);
}

export function getTypeFromUrl(url) {
  let ext = url?.split('/')?.pop();
  if(
    ext?.indexOf("mp4") > -1 || 
    ext?.indexOf("mpeg") > -1 ||
    ext?.indexOf("mpg") > -1 ||
    ext?.indexOf("avi") > -1 ||
    ext?.indexOf("flv") > -1 ||
    ext?.indexOf("mkv") > -1)
    return FileType.VIDEO;
  return FileType.IMAGE;
}

export function getFileFromBlob(blob) {

}

export function timestampFilename(file) {
  return `${Date.now()}.${extensionFromFile(file)}`
}

export function incrementMediaFilename(url) {
  var segments = _.split(url, '/');
  var oldFileName = _.last(segments);
  if(!_.includes(oldFileName, '.jpg')) {
    return null;
  }
  var fileSegments = _.split(oldFileName, '.');
  var number = _.toNumber(_.first(fileSegments));
  if(number === NaN || number === 0) {
    return null;
  }
  var newFileName = _.padEnd(number+1, 4) + '.' + _.last(fileSegments);
  return _.replace(url, oldFileName, newFileName);
}

export function isPortrait(img){
  var w = img.naturalWidth || img.width,
      h = img.naturalHeight || img.height;
  return (h > w);
}

export function resizeImageUrl(imageUrl,w,h,params={q:60}) {
  var resized = false;
  var fileExtentionType = 'jpg'
  if (!imageUrl)
    return imageUrl;
  if (imageUrl.indexOf(ImageResizer.thumbOrigBucket) >= 0) {
      imageUrl = imageUrl.replace(ImageResizer.thumbOrigBucket,ImageResizer.thumbResizedBucket)
      resized = true;
  } else if (imageUrl.indexOf(ImageResizer.profileOrigBucket) >= 0) {
      imageUrl = imageUrl.replace(ImageResizer.profileOrigBucket,ImageResizer.profileResizedBucket)
      resized = true;
  }
  if (resized) {
    if(imageUrl.slice(-4) === '.gif') {
      fileExtentionType = 'gif'
    }
    params = _.assign({
      w,
      h,
      fm: fileExtentionType,
      // Makes images too large.
      // ch: 'DPR',
      // dpr: 2,
      fit: 'max'
    }, params);
    imageUrl = imageUrl + "?" + paramsToString(params);
  }
  return imageUrl;
}

export function heightForVideo(file) {
  if(!isVideoFile(file.type)) {
    return NaN;
  }
  var video = document.createElement('video');
  video.addEventListener("load", () => {
    console.log(video, video.videoHeight)
  });
  video.src = window.URL.createObjectURL(file);
    
}

export function loadImageElement(url) {
  return new Promise((resolve, reject) => {
    var imageObj = document.createElement('img');
    if (url.substr(0, 4) === 'http') {
      // Workaround for Firefox with data URLs
      imageObj.crossOrigin = 'anonymous';
    }
    imageObj.src = url;
    if (checkIfImageLoaded(imageObj)) {
      _.defer(() => resolve(imageObj));
    } else {
      imageObj.onload = () => {
        imageObj.onload = null;
        imageObj.onerror = null;
        // Check if a valid image was loaded, to avoid "The HTMLImageElement provided is in the 'broken' state."
        if (checkIfImageLoaded(imageObj)) resolve(imageObj);
        else reject(new Error('Failed to load image with size > 0.'));
      };
      imageObj.onerror = (err) => {
        imageObj.onload = null;
        imageObj.onerror = null;
        reject(err);
      }
    }
  });
}

export function loadVideoElement(url) {
  return new Promise((resolve, reject) => {
    var videoObj = document.createElement('video');
    if (url.substr(0, 4) === 'http') {
      // Workaround for Firefox with data URLs
      videoObj.crossOrigin = 'anonymous';
    }
    videoObj.oncanplay = () => {
      videoObj.oncanplay = null;
      videoObj.onerror = null;
      resolve(videoObj);
    };
    videoObj.onerror = (err) => {
      console.warn(err.target.error);
      reject(err);
    };
    videoObj.src = url;
  });
}

  // complete + naturalWidth check from http://stackoverflow.com/a/1977898
export function checkIfImageLoaded(img) {
  // During the onload event, IE correctly identifies any images that
  // weren't downloaded as not complete. Others should too. Gecko-based
  // browsers act like NS4 in that they report this incorrectly.
  if (!img.complete) {
      return false;
  }

  // However, they do have two very useful properties: naturalWidth and
  // naturalHeight. These give the true size of the image. If it failed
  // to load, either of these should be zero.

  if (typeof img.naturalWidth !== "undefined" && img.naturalWidth === 0) {
      return false;
  }

  // No other way of checking: assume it's ok.
  return true;
}

export function captureVideoFrameAsURL(video, scaleFactor) {
  if(scaleFactor == null){
      scaleFactor = 1;
  }
  var w = video.videoWidth * scaleFactor;
  var h = video.videoHeight * scaleFactor;
  var canvas = document.createElement('canvas');
      canvas.width  = w;
      canvas.height = h;
  var ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, w, h);
  return canvas.toDataURL('image/png');
}

export function dataURLToBlob(dataURL) {
  var BASE64_MARKER = ';base64,';
  if (dataURL.indexOf(BASE64_MARKER) == -1) {
    var parts = dataURL.split(',');
    var contentType = parts[0].split(':')[1];
    var raw = decodeURIComponent(parts[1]);

    return new Blob([raw], {type: contentType});
  }

  var parts = dataURL.split(BASE64_MARKER);
  var contentType = parts[0].split(':')[1];
  var raw = window.atob(parts[1]);
  var rawLength = raw.length;

  var uInt8Array = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], {type: contentType});
}

export function blobToFile(blob, fileName) {
  blob.lastModifiedDate = new Date();
  blob.name = fileName;
  return blob;
}

export const getVideoDuration = (url) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    
    // Set up event handlers
    const handleLoadedMetadata = () => {
      const duration = video.duration;
      // Clean up
      video.removeEventListener('loadedmetadata', handleLoadedMetadata);
      video.removeEventListener('error', handleError);
      video.src = '';
      resolve(duration);
    };

    const handleError = (error) => {
      // Clean up
      video.removeEventListener('loadedmetadata', handleLoadedMetadata);
      video.removeEventListener('error', handleError);
      video.src = '';
      reject(new Error('Failed to load video metadata'));
    };

    // Add event listeners
    video.addEventListener('loadedmetadata', handleLoadedMetadata);
    video.addEventListener('error', handleError);

    // Start loading the video
    video.src = url;
  });
};
